import React from 'react';
import moment from 'moment';
import { Page, View, Image, StyleSheet, Text, Font } from '@react-pdf/renderer';
import Warranty from './warranty';
import { GetBarCode } from '../utils';
import RupeeFit from '../../assets/rupeeFit.png';
import Disclimer from '../../assets/disclimer.png';
import fonts from '../../assets/Fonts';
import {
  truncatedNumber,
  getSplitDescription,
  truncateString
} from '../../../../utils/index';
import _ from 'lodash';

Font.register(fonts);

const styles = StyleSheet.create({
  card: {
    fontFamily: 'OpenSans',
    height: '297mm',
    width: '210mm'
  },
  qrwithname: {
    display: 'flex',
    flexDirection: 'row',
    height: '84.8mm',
    borderBottom: '1 solid #000000'
  },
  qrcode: {
    width: '84.8mm',
    height: '84.8mm',
    padding: '2mm 1mm'
  },
  productname: {
    // fontFamily: 'OpenSans',
    // fontWeight: 'normal',
    fontSize: '22.6pt',
    color: 'black',
    width: '120mm',
    height: '90.8mm',
    margin: '4mm 4mm'
  },
  descriptionblock: {
    height: '195px',
    display: 'flex',
    flexDirection: 'row'
  },
  description: {
    width: '130mm',
    fontSize: '16.96pt',
    padding: '6mm 5mm',
    lineHeight: '2rem'
  },
  deals: {
    width: '70mm',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingBottom: '3mm'
  },
  mrpText: {
    fontWeight: 'bold',
    color: 'black'
  },
  rupeeSmall: {
    width: '7mm',
    height: '7mm'
  },
  mrp: { fontSize: '28.83pt', lineHeight: '12px' },
  priceBlock: {
    width: '210mm',
    borderTop: '1 solid #000000',
    borderBottom: '1 solid #000000',
    display: 'flex',
    flexDirection: 'row',
    height: '180px'
  },
  rupeeicon: {
    fontSize: '44pt',
    width: '10mm',
    paddingTop: '10mm',
    paddingLeft: '2mm'
  },
  price: {
    fontFamily: 'OpenSans',
    fontSize: '155pt',
    textAlign: 'left',
    fontWeight: 'bold',
    color: 'black',
    paddingLeft: '8mm',
    top: -22,
    lineHeight: 1
  },
  inclTax: {
    paddingTop: '53mm',
    left: -40,
    fontSize: '8.9pt'
  },

  warrantyText: {
    fontSize: '12.74pt',
    color: '#1A1818',
    opacity: '1'
  },
  barcodeBlock: {
    paddingTop: '4mm',
    width: '70mm',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'right'
  },
  barcode: {
    width: '37mm'
  },
  // Footer
  footer: {
    padding: '6mm 10mm '
  },
  dateDetails: {
    display: 'flex',
    flexDirection: 'row',
    top: 50
  },
  itemCode: {
    paddingTop: '7mm',
    fontSize: '12pt',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  lineHeight: { height: '10mm' },
  disclimer: {
    width: '4.75mm',
    height: '4.75mm',
    top: -4,
    left: 8
  }
});

const A4Portrait = ({ data, count, ...rest }) => {
  return (
    <Page size="A4" style={styles.page}>
      {count &&
        count?.map(id => (
          <View key={id}>
            {data?.map(item => {
              return (
                <View style={styles.card} key={item?.id}>
                  <View style={styles.qrwithname}>
                    <View style={styles.qrcode}>
                      <Image src={item.image} />
                    </View>
                    <View style={styles.productname}>
                      <Text>
                        {truncateString(item?.product?.masterData?.name, 130)}
                      </Text>
                      {/* <Text style={styles.lineHeight}>
                        {item?.description ||
                          item?.product?.masterData?.description ||
                          ''}
                      </Text> */}
                    </View>
                  </View>
                  <View style={styles.descriptionblock}>
                    <View style={styles.description}>
                      {/* <Text style={styles.lineHeight}>
                        {item?.description ||
                          item?.product?.masterData?.description ||
                          ''}
                      </Text> */}
                      {/* placeHolder Content */}
                      <View>
                        {getSplitDescription(item.description, 6).map(
                          (line, index) => (
                            <Text key={index}>+ {line}</Text>
                          )
                        )}
                      </View>
                    </View>
                    <View style={styles.deals}>
                      {truncatedNumber(item?.product?.mrp, 6) > 0 ? (
                        <Text style={styles.mrp}>
                          <Text style={styles.mrpText}>MRP: </Text>
                          <Image style={styles?.rupeeSmall} src={RupeeFit} />
                          {truncatedNumber(item?.product?.mrp, 6)}
                        </Text>
                      ) : (
                        <Text />
                      )}
                    </View>
                  </View>
                  <View style={styles.priceBlock}>
                    <Text style={styles.rupeeicon}>
                      <Image src={RupeeFit} />
                    </Text>
                    <View
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        left: -4
                      }}
                    >
                      <Text style={styles.price}>
                        {truncatedNumber(item?.product?.mop, 6)}
                      </Text>
                      <Text style={styles.inclTax}>*Incl. Tax</Text>
                    </View>
                  </View>
                  <View style={styles?.footer}>
                    <View
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '40mm'
                      }}
                    >
                      <Warranty warranty={item.warranty} styles={styles} />
                    </View>
                    <View
                      style={
                        item?.warranty
                          ? styles?.dateDetails
                          : { ...styles?.dateDetails, top: 165 }
                      }
                    >
                      <View style={styles.itemCode}>
                        <Text>
                          {`${item?.sku}  |  ${item.class}  |  A  |  ${moment(
                            item?.date
                          ).format('DD.MM.YYYY')}  |  ${moment().format(
                            'DD.MM.YYYY'
                          )}`}
                        </Text>
                        <View style={{ paddingTop: '3mm' }}>
                          <Image style={styles.disclimer} src={Disclimer} />
                        </View>
                      </View>

                      <View style={styles.barcodeBlock}>
                        <View style={styles.barcode}>
                          {_.isEmpty(item.barcode) ? (
                            <></>
                          ) : (
                            <Image src={GetBarCode(item?.barcode)} />
                          )}
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              );
            })}
          </View>
        ))}
    </Page>
  );
};
export { A4Portrait };
